<template>
    <div v-if="driverData" class="main-container-shipmentinfo">
        <div class="inner-container" id="printable-content">
            <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <svg
                        class="close-shipment-info"
                        @click="closeDriverInfo()"
                        viewBox="0 0 512 512"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z"
                            fill="#32ccfe"
                        />
                        <path
                            d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z"
                            fill="#32ccfe"
                        />
                    </svg>
                </div>

                <div class="confirm-header-container">
                    <h1 class="package-details-header">Driver Details</h1>

                    <img
                        src="../../../assets/LREXDinoFooter.jpg"
                        alt="LREX"
                    />
                </div>

                <div class="inner-overflow-container">
                    <div class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div class="confirmContainerInner1 driver-summary">
                                <div class="confirm-svg">
                                    <svg
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-4.418 0-8 2.239-8 5v2h16v-2c0-2.761-3.582-5-8-5z"
                                        />
                                    </svg>

                                    <h2>Driver</h2>
                                </div>

                                <div class="driver-name">
                                    {{ getDriverName(driverData) }}
                                </div>

                                <div class="detail-row">
                                    <strong>Driver Code:</strong>
                                    <span>{{ driverData.driverCode }}</span>
                                </div>

                                <div class="detail-row">
                                    <strong>Driver ID:</strong>
                                    <span>{{ driverData.driverId }}</span>
                                </div>

                                <!-- <div class="detail-row">
                                    <strong>Status:</strong>

                                    <span
                                        class="status-label"
                                        :class="{
                                            'active-status': driverData.recordStatus,
                                            'inactive-status': !driverData.recordStatus
                                        }"
                                    >
                                        {{
                                            driverData.recordStatus
                                                ? "Active"
                                                : "Inactive"
                                        }}
                                    </span>
                                </div> -->

                                <!-- <div class="detail-row">
                                    <strong>Default Route:</strong>
                                    <span>
                                        {{ driverData.defaultRoute || "None" }}
                                    </span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="inner-overflow-container">
                    <div class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div class="confirmContainerInner1 update-location">
                                <div class="confirm-svg">
                                    <svg
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm17.71-10.04a.996.996 0 0 0 0-1.41l-2.51-2.51a.996.996 0 0 0-1.41 0l-1.96 1.96 3.75 3.75 2.13-1.79z"
                                        />
                                    </svg>

                                    <h2>Update Driver</h2>
                                </div>

                                <div class="form-grid">
                                    <div class="input-group">
                                        <label for="driverCode">
                                            Driver Code
                                        </label>

                                        <input
                                            id="driverCode"
                                            v-model.trim="driverData.driverCode"
                                            type="text"
                                            disabled
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="driverId">
                                            Driver ID
                                        </label>

                                        <input
                                            id="driverId"
                                            v-model.number="driverData.driverId"
                                            type="number"
                                            disabled
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="firstName">
                                            First Name
                                        </label>

                                        <input
                                            id="firstName"
                                            v-model.trim="driverData.firstName"
                                            type="text"
                                            placeholder="First name"
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="lastName">
                                            Last Name
                                        </label>

                                        <input
                                            id="lastName"
                                            v-model.trim="driverData.lastName"
                                            type="text"
                                            placeholder="Last name"
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="email">
                                            Email
                                        </label>

                                        <input
                                            id="email"
                                            v-model.trim="driverData.email"
                                            type="text"
                                            placeholder="Email"
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="phoneNumber">
                                            Phone Number
                                        </label>

                                        <input
                                            id="phoneNumber"
                                            v-model.trim="driverData.phoneNumber"
                                            type="text"
                                            placeholder="Phone number"
                                        />
                                    </div>

                                    <div class="input-group">
                                        <label for="vendor">
                                            Vendor
                                        </label>

                                        <select
                                            id="vendor"
                                            v-model="driverData.vendor"
                                        >
                                            <option value="">
                                                {{
                                                    loadingVendors
                                                        ? "Loading vendors..."
                                                        : "No vendor"
                                                }}
                                            </option>

                                            <option
                                                v-for="vendor in vendors"
                                                :key="vendor.vendor"
                                                :value="vendor.vendor"
                                            >
                                                {{
                                                    vendor.vendorName
                                                        ? `${vendor.vendorName} (${vendor.vendor})`
                                                        : vendor.vendor
                                                }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- <div class="input-group">
                                        <label for="defaultRoute">
                                            Default Route
                                        </label>

                                        <input
                                            id="defaultRoute"
                                            v-model.trim="driverData.defaultRoute"
                                            type="text"
                                            placeholder="Default route"
                                        />
                                    </div> -->
                                </div>

                                <!-- <div class="permissions-header">
                                    <h3>Driver Settings</h3>
                                </div> -->

                                <!-- <div class="checkbox-grid">
                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.recordStatus"
                                            type="checkbox"
                                        />

                                        <span>Active</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.vehicleNeeded"
                                            type="checkbox"
                                        />

                                        <span>Vehicle Needed</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.isEmployee"
                                            type="checkbox"
                                        />

                                        <span>Employee</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.allowLegacy"
                                            type="checkbox"
                                        />

                                        <span>Allow Legacy</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.allowManifest"
                                            type="checkbox"
                                        />

                                        <span>Allow Manifest</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.addWaypoint"
                                            type="checkbox"
                                        />

                                        <span>Add Waypoint</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.addLocation"
                                            type="checkbox"
                                        />

                                        <span>Add Location</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.addShipment"
                                            type="checkbox"
                                        />

                                        <span>Add Shipment</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.routeOverRide"
                                            type="checkbox"
                                        />

                                        <span>Route Override</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.createManifestPickup"
                                            type="checkbox"
                                        />

                                        <span>Create Manifest Pickup</span>
                                    </label>

                                    <label class="checkbox-container">
                                        <input
                                            v-model="driverData.allowWarehouseScan"
                                            type="checkbox"
                                        />

                                        <span>Allow Warehouse Scan</span>
                                    </label>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <loading-charts v-if="loadingData" />

                <div class="button-container">
                    <button
                        class="print-button"
                        :disabled="loadingData"
                        @click="updateDriverProcess()"
                    >
                        {{ loadingData ? "Updating..." : "Update Driver" }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <alert-user
        v-if="toggleAlertBox"
        :message="alertMessage"
        @closeAlertBox="closeAlertBox"
    />
</template>

<script>
import { API } from "aws-amplify";
import AlertUser from "../../../components/Popups/AlertUser.vue";
import LoadingCharts from "../../ShipmentDashboard/LoadingCharts.vue";

export default {
    components: {
        AlertUser,
        LoadingCharts
    },

    props: {
        driverCode: {
            type: String,
            required: true
        },

        jwtToken: {
            type: String,
            default: null
        }
    },

    emits: [
        "closeDriverInfo",
        "closeAddressInfo",
        "driverUpdated"
    ],

    data() {
        return {
            driverData: null,
            toggleAlertBox: false,
            alertMessage: "",
            loadingData: false,
            vendors: [],
            loadingVendors: false
        };
    },

    methods: {
        getDriverName(driver) {
            const firstName = driver?.firstName ?? "";
            const lastName = driver?.lastName ?? "";

            return `${firstName} ${lastName}`.trim() || "Unnamed Driver";
        },

        normalizeBoolean(value) {
            return value === true;
        },

        normalizeDriverData(driver) {
            return {
                driverCode: driver.driverCode,
                driverId: driver.driverId,
                firstName: driver.firstName ?? "",
                lastName: driver.lastName ?? "",
                email: driver.email ?? "",
                recordStatus: this.normalizeBoolean(driver.recordStatus),
                vehicleNeeded: this.normalizeBoolean(driver.vehicleNeeded),
                isEmployee: this.normalizeBoolean(driver.isEmployee),
                allowLegacy: this.normalizeBoolean(driver.allowLegacy),
                allowManifest: this.normalizeBoolean(driver.allowManifest),
                addWaypoint: this.normalizeBoolean(driver.addWaypoint),
                addLocation: this.normalizeBoolean(driver.addLocation),
                addShipment: this.normalizeBoolean(driver.addShipment),
                defaultRoute: driver.defaultRoute ?? "",
                routeOverRide: this.normalizeBoolean(driver.routeOverRide),
                createManifestPickup: this.normalizeBoolean(
                    driver.createManifestPickup
                ),
                allowWarehouseScan: this.normalizeBoolean(
                    driver.allowWarehouseScan
                ),
                vendor: driver.vendor ?? "",
                phoneNumber: driver.phoneNumber ?? ""
            };
        },

        // Inline query that omits createdAt/updatedAt to avoid AWSDateTime null issues.
        async listVendors() {
            this.loadingVendors = true;

            let vendors = [];
            let nextToken = null;

            try {
                do {
                    const response = await API.graphql({
                        query: `query listVendors($nextToken: String) {
                            listVendors(limit: 1000, nextToken: $nextToken) {
                                items {
                                    vendor
                                    vendorName
                                }
                                nextToken
                            }
                        }`,
                        variables: {
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS"
                    });

                    const data = response.data.listVendors;

                    vendors = vendors.concat(data.items || []);
                    nextToken = data.nextToken;
                } while (nextToken);

                vendors.sort((a, b) =>
                    (a.vendorName || a.vendor || "").localeCompare(
                        b.vendorName || b.vendor || ""
                    )
                );

                this.vendors = vendors;
            } catch (error) {
                console.error("Error listing vendors:", error);
            } finally {
                this.loadingVendors = false;
            }
        },

        async getDriverForTable() {
            this.loadingData = true;

            const graphqlQuery = `
                query GetDriver($driverCode: String!) {
                    getDriver(driverCode: $driverCode) {
                        driverCode
                        driverId
                        email
                        firstName
                        lastName
                        recordStatus
                        vehicleNeeded
                        isEmployee
                        allowLegacy
                        allowManifest
                        addWaypoint
                        addLocation
                        addShipment
                        defaultRoute
                        routeOverRide
                        createManifestPickup
                        allowWarehouseScan
                        vendor
                        phoneNumber
                    }
                }
            `;
            console.log("GET DATA")
            try {
                const response = await API.graphql({
                    query: graphqlQuery,
                    variables: {
                        driverCode: this.driverCode
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                const driver = response.data.getDriver;

                if (!driver) {
                    throw new Error("Driver not found.");
                }

                this.driverData = this.normalizeDriverData(driver);
            } catch (error) {
                console.error("Error getting driver:", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Error getting driver information.";
            } finally {
                this.loadingData = false;
            }
        },

        validateDriver() {
            if (!this.driverData) {
                return false;
            }

            if (!this.driverData.driverCode?.trim()) {
                this.toggleAlertBox = true;
                this.alertMessage = "Driver code is required.";

                return false;
            }

            if (
                this.driverData.driverId === null ||
                this.driverData.driverId === undefined
            ) {
                this.toggleAlertBox = true;
                this.alertMessage = "Driver ID is required.";

                return false;
            }

            return true;
        },

        async updateDriverProcess() {
            if (!this.validateDriver()) {
                return;
            }

            this.loadingData = true;

            try {
                await this.updateDriverInfo();

                this.toggleAlertBox = true;
                this.alertMessage = "Driver updated.";

                this.$emit("driverUpdated", this.driverData);
            } catch (error) {
                console.error("Error updating driver:", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Error updating driver.";
            } finally {
                this.loadingData = false;
            }
        },

        async updateDriverInfo() {
            const input = {
                driverCode: this.driverData.driverCode,
                driverId: Number(this.driverData.driverId),
                firstName: this.driverData.firstName?.trim() || "",
                lastName: this.driverData.lastName?.trim() || "",
                email: this.driverData.email?.trim() || "",
                recordStatus: this.driverData.recordStatus,
                vehicleNeeded: this.driverData.vehicleNeeded,
                isEmployee: this.driverData.isEmployee,
                allowLegacy: this.driverData.allowLegacy,
                allowManifest: this.driverData.allowManifest,
                addWaypoint: this.driverData.addWaypoint,
                addLocation: this.driverData.addLocation,
                addShipment: this.driverData.addShipment,
                defaultRoute:
                    this.driverData.defaultRoute?.trim() || "",
                routeOverRide: this.driverData.routeOverRide,
                createManifestPickup:
                    this.driverData.createManifestPickup,
                allowWarehouseScan:
                    this.driverData.allowWarehouseScan,
                vendor: this.driverData.vendor?.trim() || null,
                phoneNumber: this.driverData.phoneNumber?.trim() || null
            };

            // Inline mutation that omits createdAt/updatedAt to avoid
            // AWSDateTime null issues (established codebase pattern).
            const updateDriverMutation = `
                mutation UpdateDriver($input: UpdateDriverInput!) {
                    updateDriver(input: $input) {
                        driverCode
                        driverId
                        firstName
                        lastName
                        email
                        recordStatus
                        vehicleNeeded
                        isEmployee
                        allowLegacy
                        allowManifest
                        addWaypoint
                        addLocation
                        addShipment
                        defaultRoute
                        routeOverRide
                        createManifestPickup
                        allowWarehouseScan
                        vendor
                        phoneNumber
                    }
                }
            `;

            const response = await API.graphql({
                query: updateDriverMutation,
                variables: {
                    input
                },
                authMode: "AMAZON_COGNITO_USER_POOLS"
            });

            const updatedDriver = response.data.updateDriver;

            if (updatedDriver) {
                this.driverData = this.normalizeDriverData(updatedDriver);
            } else {
                await this.getDriverForTable();
            }

            return updatedDriver;
        },

        closeAlertBox(toggleAlertBox) {
            this.toggleAlertBox = toggleAlertBox;
        },

        closeDriverInfo() {
            this.$emit("closeDriverInfo", false);

            // This keeps the component compatible with the existing
            // Dropbox parent event while you transition its naming.
            this.$emit("closeAddressInfo", false);
        }
    },

    mounted() {
        this.getDriverForTable();
        this.listVendors();

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
};
</script>

<style scoped>
input,
select {
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0, 0, 0, 0.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    box-sizing: border-box;
}

input:disabled {
    background-color: #e9e9e9;
    color: #777777;
    cursor: not-allowed;
}

.main-container-shipmentinfo {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 20px 0;
    z-index: 10;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.08);
}

@keyframes shipment-details-animate {
    from {
        opacity: 0;
        transform: translateY(-15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.inner-container {
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    flex-direction: column;
    box-sizing: border-box;
}

.confirm-container-main {
    position: relative;
    display: flex;
    flex-direction: column;
    width: min(750px, 92%);
    max-height: calc(100vh - 40px);
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
    flex-shrink: 0;
    animation: shipment-details-animate 0.5s ease;
    background-color: #ffffff;
    border-radius: 25px;
    box-sizing: border-box;
    box-shadow:
        rgba(0, 0, 0, 0.25) 0 54px 55px,
        rgba(0, 0, 0, 0.12) 0 -12px 30px,
        rgba(0, 0, 0, 0.12) 0 4px 6px,
        rgba(0, 0, 0, 0.17) 0 12px 13px,
        rgba(0, 0, 0, 0.09) 0 -3px 5px;
}

.close-shipment-info-container {
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    padding: 8px 15px 4px;
    background-color: #ffffff;
    box-sizing: border-box;
}

.close-shipment-info {
    width: 30px;
    height: 30px;
    margin: 0;
    flex-shrink: 0;
    transition-duration: 0.5s;
    cursor: pointer;
}

.close-shipment-info:hover {
    border-radius: 999px;
    background-color: #e4e4e4;
}

.confirm-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    padding: 0 15px;
    box-sizing: border-box;
}

.confirm-header-container img {
    width: 40px;
    margin-right: 15px;
}

.package-details-header {
    width: fit-content;
    margin: 0;
    padding: 10px 18px;
    color: #ffffff;
    background-color: #32ccfe;
    border-radius: 50px;
}

.inner-overflow-container {
    margin: 5px;
    border-top: 1px solid #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
}

.confirmContainerInner {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: left;
    padding: 10px;
}

.confirm-container-address {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
}

.confirmContainerInner1 {
    flex-basis: 100%;
    margin: 5px;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 25px;
    box-sizing: border-box;
    box-shadow: rgb(0 0 0 / 16%) 0 1px 10px;
}

.confirm-svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    margin-bottom: 10px;
    padding: 5px 12px;
    background-color: #e4e4e4;
    border-radius: 999px;
}

.confirm-svg svg {
    width: 30px;
    height: 30px;
    padding-right: 7px;
}

.confirm-svg h2 {
    margin: 0;
    white-space: nowrap;
}

.driver-name {
    margin: 10px 0;
    font-size: 22px;
    font-weight: bold;
}

.detail-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 7px 0;
}

.status-label {
    padding: 3px 10px;
    font-size: 12px;
    border-radius: 999px;
}

.active-status {
    color: #15763a;
    background-color: #c7f5d7;
}

.inactive-status {
    color: #666666;
    background-color: #e1e1e1;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.input-group {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.input-group label {
    margin-left: 7px;
    font-weight: bold;
}

.permissions-header {
    margin-top: 18px;
    padding-top: 12px;
    border-top: 1px solid #d5d5d5;
}

.permissions-header h3 {
    margin: 0 0 10px;
}

.checkbox-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    padding: 9px 12px;
    background-color: #ffffff;
    border-radius: 15px;
    cursor: pointer;
}

.checkbox-container span {
    margin-left: 9px;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    display: grid;
    place-content: center;
    width: 1.15em;
    height: 1.15em;
    margin: 0;
    padding: 0;
    font: inherit;
    color: #33f18a;
    background-color: #ffffff;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    cursor: pointer;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    background-color: #33f18a;
    clip-path: polygon(
        14% 44%,
        0 65%,
        50% 100%,
        100% 16%,
        80% 0%,
        43% 62%
    );
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container {
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
    padding: 0 20px 10px;
}

.print-button {
    width: fit-content;
    padding: 8px 18px;
    color: #000000;
    background-color: #33f18a;
    border: none;
    border-radius: 999px;
    transition-duration: 0.5s;
    cursor: pointer;
}

.print-button:hover {
    background-color: #31d77b;
}

.print-button:disabled {
    background-color: #d5d5d5;
    cursor: not-allowed;
}

@media only screen and (max-width: 820px) {
    .main-container-shipmentinfo {
        padding: 10px 0;
    }

    .confirm-container-main {
        width: 94%;
        max-height: calc(100vh - 20px);
        border-radius: 18px;
    }

    .form-grid,
    .checkbox-grid {
        grid-template-columns: 1fr;
    }

    .package-details-header {
        font-size: 1.6em;
    }

    .confirm-header-container {
        padding-bottom: 5px;
    }
}

@media only screen and (max-width: 530px) {
    .main-container-shipmentinfo {
        padding: 5px 0;
    }

    .confirm-container-main {
        width: 96%;
        max-height: calc(100vh - 10px);
        border-radius: 14px;
    }

    .close-shipment-info-container {
        padding: 7px 10px 3px;
    }

    .confirm-header-container {
        padding: 0 10px 5px;
    }

    .confirm-header-container img {
        width: 34px;
        margin-right: 5px;
    }

    .package-details-header {
        padding: 8px 14px;
        font-size: 1.25em;
    }

    .confirmContainerInner {
        padding: 5px;
    }

    .confirmContainerInner1 {
        margin: 3px;
        padding: 12px;
        border-radius: 18px;
    }

    .detail-row {
        align-items: flex-start;
        flex-direction: column;
        gap: 2px;
    }

    .button-container {
        padding: 0 12px 10px;
    }
}
</style>